import styled from "styled-components";
import { Badge } from "antd";
import { theme } from "../../../config";

export const BadgeStyled = styled(Badge)`
  .ant-badge-count {
    background: rgba(255, 255, 255, 0.4);
    border: none;
    color: ${theme.colors.primary};
  }
`;
